import { emailPattern, eppnPattern, faultyEppnPattern, studentEppnPattern } from "./regexPatterns";
/**
 * Validate that the value is a plausible username. The returned string should be a translate() lookup key.
 * @param values
 * @returns
 */
export function validateUserNameInForm(values) {
    const errors = {};
    if (values !== undefined) {
        errors.username = validateUserNameField(values.username);
    }
    return errors;
}
// backwards compat export
export const validate = validateUserNameInForm;
/**
 * Validate that the value is a plausible username. The returned string should be a translate() lookup key.
 * @param values
 * @returns
 */
export function validateUserNameField(value) {
    const stringWithoutSpaces = value === null || value === void 0 ? void 0 : value.replaceAll(/\s/g, "");
    if (!stringWithoutSpaces) {
        return "required";
    }
    else if (faultyEppnPattern.test(stringWithoutSpaces)) {
        return "invalid username";
    }
    else if (eppnPattern.test(stringWithoutSpaces)) {
        return undefined;
    }
    else if (studentEppnPattern.test(stringWithoutSpaces)) {
        return undefined;
    }
    else if (emailPattern.test(stringWithoutSpaces)) {
        return undefined;
    }
    else
        return "invalid username";
}
